export default {
  'sequences.title': 'Manage Sequences',
  'sequence.pattern': 'Pattern',
  'sequence.subSequences': 'Subsequences',
  'sequence.sequenceTraces': 'Traces',
  'sequence.automaticNumbersCurrentYear': 'Current Year - Automatic Numbering',
  'sequence.automaticNumbersCurrentMonth': 'Current Month - Automatic Numbering',
  'sequence.automaticNumbersCurrentDay': 'Current Day - Automatic Numbering',
  'sequence.lastGeneratedNumber': 'Last Generated Number',
  'sequence.rowVersion': 'Row Version',
  'sequence.sequenceItem': 'Subsequence',
  'sequence.generatedNumber': 'Generated Number',
  'sequence.referenceItemId': 'Reference ID',
  'sequence.referenceItemDescription': 'Reference Description',
  'sequence.referenceEntity': 'Reference Entity',
};
